module.exports = __webpack_public_path__ + "static/media/Take Up Rollers 2.4c324426.jpg";